/**
 * BE 매핑 JSON 의 모양 검사와 키 순서.
 *
 * 읽기 스키마(`mapping.read.schema.json`)를 쓴다. 그래서 기본값이 있는 키도 모두 있어야 통과한다. BE 응답은
 * 항상 전체 키를 가진다. 스키마가 적지 못하는 규칙은 BE 만 거부한다. 예) 한 선택 안의 중복 열, 평행한
 * 손 축, 같은 값의 그리퍼 입력 끝점.
 */
import { createSchemaChecker, orderKeysBySchema } from "@/shared/json";
import readSchema from "./mapping.read.schema.json";
import type { Mapping } from "./mappingSchema.generated";

export const checkMapping = createSchemaChecker<Mapping>(readSchema);

/** 키를 스키마 순서로 놓은 사본. 값은 그대로다. 사람이 읽는 JSON 을 늘 같은 순서로 쓴다. */
export function orderMappingKeys(mapping: Mapping): Mapping {
  return orderKeysBySchema(mapping, readSchema) as Mapping;
}
